import { MouseEvent, useState } from "react";

import { AttachFileRounded, FilePresentRounded } from "@mui/icons-material";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { IconButton, ListItem, Popover } from "@mui/material";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";

import { UserSummaryFileType } from "@interfaces/chat.type";

import theme from "@theme/index";

interface ISelectFilePopoverProperties {
  files: UserSummaryFileType[];
  handleFileButtonClick?: () => void;
  handleFileClick?: (file: UserSummaryFileType) => void;
}

const SelectFilePopover = ({ files, handleFileButtonClick, handleFileClick }: ISelectFilePopoverProperties) => {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);

  const handleOpenPopover = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorElement(null);
  };
  return (
    <>
      <IconButton
        onClick={handleOpenPopover}
        sx={{
          "&:hover": {
            color: theme.palette.info.main,
          },
          height: "30px",
          transition: "color 0.1s ease-in-out",
          width: "30px",
        }}
      >
        <AttachFileRounded sx={{ fontSize: "20px" }} />
      </IconButton>
      <Popover
        anchorEl={anchorElement}
        anchorOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
        onClose={handleClosePopover}
        open={Boolean(anchorElement)}
        sx={{
          pt: 0,
          transform: "translateY(-40px)",
        }}
      >
        <Box sx={{ backgroundColor: "white" }}>
          <List sx={{ p: 0 }}>
            {files.map((file) => (
              <ListItem
                key={file.id}
                onClick={() => handleFileClick?.(file)}
                sx={{
                  ":hover": { backgroundColor: theme.palette.grey[200] },
                  "&:last-child": {
                    borderBottom: `1px solid ${theme.palette.grey[300]}`,
                  },
                  cursor: "pointer",
                  p: 2,
                }}
              >
                <FilePresentRounded sx={{ fontSize: "18px", mr: 1 }} />
                <Typography fontWeight={400}>{file.fileName}</Typography>
              </ListItem>
            ))}
          </List>

          <Box
            onClick={handleFileButtonClick}
            sx={{
              "&:hover": { backgroundColor: theme.palette.grey[200] },
              alignItems: "center",
              cursor: "pointer",
              display: "flex",
              gap: 0.5,
              p: 1.5,
            }}
          >
            <FileUploadRoundedIcon />
            <Typography variant="body2">Upload from computer</Typography>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default SelectFilePopover;
